if (!customElements.get('nested-tabs-menu')) {
  var SWAP_DURATION = 0.4;
  var SWAP_EASING = [0.22, 1, 0.36, 1];

  class NestedTabsMenu extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll(':scope > .nested-tabs__row > .nested-tabs__tab');
      this.panels = this.querySelectorAll(':scope > [data-viewport] > .nested-tabs__panel');
      this.viewport = this.querySelector(':scope > [data-viewport]');
      this.indicator = this.querySelector('[data-tabs-indicator]');

      var self = this;
      requestAnimationFrame(function () {
        self.moveIndicator(self.tabs[0]);
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          var active = self.querySelector(':scope > .nested-tabs__row > .nested-tabs__tab.is-active');
          if (active) self.moveIndicator(active);
        });
      }

      this.tabs.forEach(function (tab, index) {
        self.wireTrigger(tab, function () {
          self.activateTab(tab, index);
        });
      });

      this.panels.forEach(function (panel) {
        var subtabs = panel.querySelectorAll(':scope > .nested-tabs__subrow > .nested-tabs__subtab');
        var subviewport = panel.querySelector(':scope > [data-subviewport]');
        var subpanels = subviewport
          ? subviewport.querySelectorAll(':scope > .nested-tabs__subpanel')
          : panel.querySelectorAll(':scope > .nested-tabs__subpanel');
        subtabs.forEach(function (subtab, index) {
          self.wireTrigger(subtab, function () {
            self.activateSubtab(subtab, subtabs, subpanels, subviewport, index);
          });
        });
      });

      window.addEventListener('resize', function () {
        var active = self.querySelector(':scope > .nested-tabs__row > .nested-tabs__tab.is-active');
        if (active) self.moveIndicator(active);
      });
    }

    wireTrigger(el, activate) {
      var timer;
      el.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(activate, 90);
      });
      el.addEventListener('mouseleave', function () {
        clearTimeout(timer);
      });
      el.addEventListener('focus', activate);
      el.addEventListener('click', activate);
    }

    moveIndicator(tab) {
      if (!this.indicator || !tab) return;
      this.indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px) scaleX(' + tab.offsetWidth + ')';
    }

    activateTab(tab, index) {
      this.moveIndicator(tab);
      if (tab.classList.contains('is-active')) return;
      var oldTab = this.querySelector(':scope > .nested-tabs__row > .nested-tabs__tab.is-active');
      var oldIndex = oldTab ? Array.prototype.indexOf.call(this.tabs, oldTab) : -1;
      this.tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      this.swapPanel(this.panels, this.viewport, oldIndex, index);
    }

    activateSubtab(subtab, subtabs, subpanels, subviewport, index) {
      if (subtab.classList.contains('is-active')) return;
      var oldSubtab = null;
      for (var i = 0; i < subtabs.length; i++) {
        if (subtabs[i].classList.contains('is-active')) {
          oldSubtab = subtabs[i];
          break;
        }
      }
      var oldIndex = oldSubtab ? Array.prototype.indexOf.call(subtabs, oldSubtab) : -1;
      subtabs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      subtab.classList.add('is-active');
      this.swapPanel(subpanels, subviewport, oldIndex, index);
    }

    // Directional slide: hovering a tab to the left slides the current panel
    // out to the right while the new one enters from the left, and vice versa
    // — same idea as a filmstrip/carousel swap. Falls back to an instant swap
    // if there's no previous panel (first paint) or Motion One isn't ready.
    swapPanel(panels, viewport, oldIndex, newIndex) {
      var newPanel = panels[newIndex];
      var oldPanel = oldIndex >= 0 && oldIndex !== newIndex ? panels[oldIndex] : null;

      if (!oldPanel || !viewport || !window.motion || !window.motion.animate) {
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
        newPanel.classList.add('is-active');
        return;
      }

      var goingForward = newIndex > oldIndex;
      var exitX = goingForward ? '-100%' : '100%';
      var enterFromX = goingForward ? '100%' : '-100%';
      var oldHeight = viewport.offsetHeight;

      [oldPanel, newPanel].forEach(function (p) {
        p.style.position = 'absolute';
        p.style.top = '0';
        p.style.left = '0';
        p.style.width = '100%';
      });
      newPanel.classList.add('is-active');

      var newHeight = newPanel.scrollHeight;
      viewport.style.height = oldHeight + 'px';

      motion.animate(
        viewport,
        { height: [oldHeight + 'px', newHeight + 'px'] },
        { duration: SWAP_DURATION, easing: SWAP_EASING }
      );
      motion.animate(
        oldPanel,
        { transform: ['translateX(0)', 'translateX(' + exitX + ')'], opacity: [1, 0] },
        { duration: SWAP_DURATION, easing: SWAP_EASING }
      );
      var enterAnim = motion.animate(
        newPanel,
        { transform: ['translateX(' + enterFromX + ')', 'translateX(0)'], opacity: [0, 1] },
        { duration: SWAP_DURATION, easing: SWAP_EASING }
      );

      enterAnim.finished.then(function () {
        oldPanel.classList.remove('is-active');
        [oldPanel, newPanel].forEach(function (p) {
          p.style.position = '';
          p.style.top = '';
          p.style.left = '';
          p.style.width = '';
          p.style.transform = '';
          p.style.opacity = '';
        });
        viewport.style.height = '';
      });
    }
  }

  customElements.define('nested-tabs-menu', NestedTabsMenu);
}
